<template>
  <div class="w-full">
    <div class="flex flex-row justify-between content-center mb-4">
      <div class="mx-auto container flex flex-row items-end space-x-2">
        <div class="flex-1">
          <input
            type="text"
            name="searchText"
            id="searchText"
            placeholder="Search by a title, keyword, tag, or YouTube ID..."
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            v-model="searchQuery"
          />
        </div>
        <!-- <div>
          <input
            type="date"
            name="startDate"
            id="searchText"
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            v-model="searchDate"
          />
        </div> -->

        <div>
          <select
            class="block w-full pl-3 pr-10 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
            v-model="searchFilter"
          >
            <option value="desc">Newest First</option>
            <option value="asc">Oldest First</option>
          </select>
        </div>
        <div class="space-x-2 h-full">
          <button
            class="px-4 py-2 bg-white rounded-md focus:outline-none sm:text-sm h-full"
            v-on:click="resetButtonClick()"
          >
            Reset
          </button>
        </div>
        <div class="rounded-md overflow-hidden hidden lg:inline-block h-full">
          <button
            class="focus:outline-none py-2.5 px-4 h-full"
            :class="{
              'bg-white text-black': display !== '2col',
              'bg-gray-600 text-white': display == '2col'
            }"
            v-on:click="display = '2col'"
          >
            <i class="fa-solid fa-grid-2 flex items-center justify-center"></i>
          </button>
          <button
            class="focus:outline-none py-2.5 px-4 h-full"
            :class="{
              'bg-white text-black': display !== 'full',
              'bg-gray-600 text-white': display == 'full'
            }"
            v-on:click="display = 'full'"
          >
            <i class="fa-solid fa-bars flex items-center justify-center"></i>
          </button>
        </div>
      </div>
    </div>
    <div
      class="grid grid-cols-1 gap-4"
      :class="{
        'lg:grid-cols-1': display == 'full',
        'lg:grid-cols-2': display == '2col'
      }"
    >
      <div
        class="bg-white rounded-md shadow-md flex flex-row p-2 relative overflow-hidden group select-none"
        v-for="video in videos"
        v-bind:key="video.id"
      >
        <!-- Hover over animation -->
        <div
          class="absolute w-full h-full backdrop-filter backdrop-blur-sm z-30 -m-2 opacity-0 group-hover:opacity-100 transition-all flex flex-row content-center justify-center items-center space-x-4"
        >
          <div
            class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
            v-on:click="viewVideo(video)"
          >
            <i class="fa-solid fa-eye"></i>
          </div>
          <div
            class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
            v-on:click="editVideo(video)"
          >
            <i class="fa-solid fa-pen"></i>
          </div>
          <div
            class="bg-blue-600 text-white rounded-full w-10 h-10 inline-flex items-center content-center justify-center cursor-pointer hover:bg-blue-500"
            v-on:click="downloadVideo(video.id)"
          >
            <i class="fa-solid fa-download"></i>
          </div>
          <div class="absolute top-0 right-0 flex flex-row p-2">
            <i
              class="fa-solid fa-circle-exclamation text-red-600 mt-3 mr-2 z-50 bg-white rounded-full"
              :title="'Embargo: ' + video.embargo"
              v-tippy
              v-if="video.embargo"
            ></i>
            <span
              class="px-2 pt-0.5 text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-700 m-0 uppercase"
              v-if="video.status == 'approved'"
              v-tippy
              :title="vTippyTitle(video)"
            >
              Approved
            </span>
          </div>
        </div>

        <div
          class="flex-none flex flex-col items-center content-center w-48 relative"
        >
          <div
            class="absolute top-0 left-0 mt-2 ml-2 bg-blue-500 rounded-md text-white z-10 text-xs px-1.5 py-0.5"
          >
            {{ video.length | timecode }}
          </div>
          <progressive-img
            class="rounded-md z-0"
            style="aspect-ratio: 16 / 9;"
            fallback="/static/image-unavailable.png"
            :src="video.thumbnailUrl"
          />
        </div>

        <div
          class="flex flex-col pl-2 whitespace-nowrap overflow-ellipsis overflow-hidden relative"
        >
          <div class="flex flex-row">
            <p
              class="whitespace-nowrap overflow-ellipsis overflow-hidden flex-1"
            >
              <strong class="text-red-600" v-if="video.status == 'pending'"
                >PENDING</strong
              >
              {{ video.title }}
            </p>
            <span
              class="px-2 pt-0.5 text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-700 m-0 uppercase"
              v-if="video.status == 'approved'"
              v-tippy
              :title="vTippyTitle(video)"
            >
              Approved
            </span>
          </div>

          <div class="flex flex-row space-x-4">
            <div class="">
              <i class="fa-regular fa-clock text-gray-500"></i>
              {{ video.created_at | displayLocalDateTime }}
            </div>
            <div class="">
              <i class="fa-regular fa-tag text-gray-500"></i>
              {{
                video.tags !== null
                  ? video.tags.length > 1
                    ? video.tags.length + " tags"
                    : video.tags.length + " tag"
                  : "0 tags"
              }}
            </div>
            <div class="">
              <i class="fa-regular fa-earth-americas text-gray-500"></i>
              {{
                video.locations !== null
                  ? video.locations.length > 1
                    ? video.locations.length + " locations"
                    : video.locations.length + " location"
                  : "0 locations"
              }}
            </div>
          </div>

          <div
            class="w-full rounded-md text-red-500"
            v-if="video.status == 'declined' && video.declined_message !== null"
          >
            This video was declined.
          </div>

          <div class="pt-2 whitespace-nowrap overflow-ellipsis overflow-hidden">
            {{ video.description }}
          </div>
        </div>
      </div>
    </div>
    <div ref="loadMoreDiv" class="h-10"></div>

    <ViewVideoModal />
    <EditVideoModal />
  </div>
</template>

<script>
import * as Config from "@/config";

import ViewVideoModal from "@/screens/stringer/modals/ViewVideoModal";
import EditVideoModal from "@/screens/stringer/modals/EditVideoDetails";
import Dropdown from "@/components/partials/Dropdown";
import { displayLocalDateTime, capitalize } from "@/filters";
import { mapActions } from "vuex";

export default {
  name: "StringerVideos",
  data() {
    return {
      videos: [],

      resource_url: Config.apiPath + "/api/v2/stringer/videos",
      current_page: 1,

      index: 1,
      last_page: null,
      polling: true,
      bottom: false,

      shouldLoadMore: null,

      display: "2col",

      searchFilter: "desc",
      searchQuery: "",
      searchDate: null,
      fetching: false
    };
  },
  components: {
    ViewVideoModal,
    EditVideoModal,
    Dropdown
  },
  mounted() {
    this.$nextTick(async () => {
      await this.search();
      this.handleScroll();

      this.$eventBus.$on("scroll", this.bottomVisible);
      this.shouldLoadMore = setInterval(
        function() {
          this.bottomVisible();
        }.bind(this),
        250
      );
    });
  },
  destroyed() {
    this.$eventBus.$off("scroll");
    clearInterval(this.shouldLoadMore);
  },
  watch: {
    bottom: async function(bottom) {
      if (bottom) {
        await this.search();
      }
    },
    searchQuery: function() {
      this.reset();
      this.searching = true;
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.search();
      }, 600);
    },
    searchFilter: function() {
      this.reset();
      this.searching = true;
      this.search();
    }
  },
  methods: {
    ...mapActions(["addToastMessage"]),

    computeResourceUrl() {
      var baseURL = this.resource_url + "?page=" + this.current_page;

      if (this.searchQuery !== "" && this.searchQuery !== null) {
        baseURL += "&search=" + this.searchQuery;
      }

      if (this.searchFilter !== null) {
        baseURL += "&orderBy=" + this.searchFilter;
      }

      return baseURL;
    },

    async resetButtonClick() {
      this.searchQuery = null;
      this.searchFilter = "desc";
      await this.reset();
      await this.search();
    },

    async search() {
      let url = this.computeResourceUrl();

      // if (this.fetching) return;
      // this.fetching = true;
      try {
        let res = await this.$http.get(url);
        this.current_page = res.data.current_page + 1;
        this.videos = this.videos.concat(res.data.data);
        this.last_page = res.data.last_page;
        this.polling = false;
        this.searching = false;
        this.fetching = false;
        this.index += 1;
      } catch (e) {
        this.searching = false;
        this.fetching = false;
        this.polling = false;
        this.addToastMessage({
          title: "Error",
          text: "We have encountered an error loading more videos, try again.",
          type: "error"
        });
      }
      // if (this.last_page !== null && this.index > this.last_page) return;
    },

    async downloadVideo(id) {
      let _this = this;
      try {
        await this.$http
          .get(Config.apiPath + "/api/v2/stringer/videos/" + id + "/download")
          .then(response => {
            var link = document.createElement("a");
            document.body.appendChild(link);
            link.href = response.data;
            link.click();
            document.body.removeChild(link);
            _this.addToastMessage({
              title: "Success",
              text: "Your file is currently downloading.",
              type: "success"
            });
          });
      } catch (e) {
        _this.addToastMessage({
          title: "Error",
          text: "You cannot download this file because it is not yours.",
          type: "error"
        });
      }
    },
    viewVideo(video) {
      this.$eventBus.$emit("stringer-view-video-open-modal", video);
    },
    editVideo(video) {
      this.$eventBus.$emit("stringer-edit-video-open-modal", video);
    },

    infiniteHandler($state) {
      var _this = this;

      this.$http
        .get(this.resource_url + "?page=" + this.current_page)
        .then(response => {
          _this.current_page = response.data.current_page + 1;

          var data = response.data.data;

          const temp = [];
          for (var i = 0; i < data.length; i++) {
            temp.push(data[i]);
          }
          _this.videos = _this.videos.concat(temp);

          $state.loaded();
        });
    },
    vTippyTitle(video) {
      try {
        let approvedDt = displayLocalDateTime(
          video.meta.videoApproved.meta.timestamp
        );
        return (
          capitalize(video.meta.videoApproved.meta.status) +
          " by " +
          video.meta.videoApproved.meta.by.name +
          " at " +
          approvedDt
        );
      } catch (e) {
        return "Error looking up video approval information.";
      }
    },
    handleScroll() {
      this.bottom = this.bottomVisible();
    },
    bottomVisible() {
      const rect = this.$refs.loadMoreDiv.getBoundingClientRect();

      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      this.bottom = isInViewport;

      return isInViewport;
    },
    reset() {
      this.current_page = 1;
      this.videos = [];
    }
  }
};
</script>

<style scoped></style>
